import {EventEmitter} from 'events';

const reviewEventBus = new EventEmitter();

export default reviewEventBus;